export default {
}



// WEBPACK FOOTER //
// src/store/mario/google/getters.js